import styled from 'styled-components';
import { palette } from 'styled-tools';

import { fontWeight, FontWeights, minWidth } from '@calm-web/design-system';

import GridWrapper from '@/components/ui/GridWrapper';

export const Wrapper = styled.section`
	background: ${palette('schoolBabyBlue')};
	margin: 0 auto;
	max-width: 1440px;
	position: relative;
`;

export const Grid = styled(GridWrapper)`
	grid-template-columns: 1fr;
	padding: 24px 0;

	${minWidth('tablet')} {
		grid-template-columns: 1fr 1fr;
	}
`;

export const Photo = styled.div`
	aspect-ratio: 1.03;
	position: relative;
	width: 100%;
`;

export const Heading = styled.h1`
	${fontWeight(FontWeights.Regular)};
	margin-bottom: 48px;
	position: relative;

	& span {
		position: relative;

		&:after {
			background-image: url('/_n/images/schools/double-underline.webp');
			background-repeat: no-repeat;
			background-size: contain;
			content: '';
			display: block;
			height: 55px;
			left: 50%;
			position: absolute;
			transform: translate3d(-50%, -10px, 0);
			width: 159px;
		}
	}
`;

export const ContentWrapper = styled.div``;

export const Benefit = styled.h5`
	${fontWeight(FontWeights.Regular)};
	margin-bottom: 24px;

	${minWidth('tablet')} {
		margin-bottom: 36px;
	}

	${minWidth('desktop')} {
		margin-bottom: 24px;
	}
`;
